/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsCountryMessageData } from './lds-country-message.data';
import { ILdsCountryMessageProps } from './lds-country-message.props.autogenerated';

export interface ILdsCountryMessageViewProps extends ILdsCountryMessageProps<ILdsCountryMessageData> {}

/**
 *
 * LdsCountryMessage component
 * @extends {React.PureComponent<ILdsCountryMessageProps<ILdsCountryMessageData>>}
 */
class LdsCountryMessage extends React.PureComponent<ILdsCountryMessageProps<ILdsCountryMessageData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsCountryMessage;
